import { FormattedMessage, useIntl } from 'react-intl';

import { Modal, ResponsiveWidth } from '..';
import { IModalProps } from '..';
import { useStyles } from './unknown-error-modal.styles';
import { Button } from '../button-new';
import { PHONE_SUPPORT_HREF } from '../../../constants/common';

export const UnknownErrorModal = ({ onClose, ...props }: IModalProps): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();

  const handleClose = () => {
    onClose!();
  };

  return (
    <Modal
      {...props}
      onClose={handleClose}
      data-testid="unknown-error-modal"
      title={<FormattedMessage id="common.errors.unknownError.title" />}
      titleStyles={classes.title}
      propsPaperStyles={classes.paper}
      content={
      <>
        <p data-testid="unknown-error-content" className={classes.content}>
          <FormattedMessage id="common.errors.unknownError.content" />
        </p>
        <div className={classes.footerButtons}>
          <Button
            style="dark"
            testId="call-button"
            aria-label={intl.formatMessage({ id: 'order.callSupport.modal.callButton.ariaLabel' })}
            to={PHONE_SUPPORT_HREF}
          >
            <FormattedMessage id="common.errors.callSupport" />
          </Button>
          <Button
            style="outlined"
            onClick={handleClose}
            testId="get-button"
            aria-label={intl.formatMessage({ id: 'order.callSupport.modal.getButton.ariaLabel' })}
          >
            <FormattedMessage id="common.gotIt" />
          </Button>
        </div>
      </>
      }
      responsiveWidth={ResponsiveWidth.mdWider}
    />
  );
};
